/**
 * Spawnry Client-side Configuration
 * Contains company-specific information for the frontend
 */
export const appConfig = {
    // Contact Information
    contact: {
        primary: {
            name: 'Spawnry Support',
            email: 'support@spawnry.ai'
        },
        support: {
            email: 'support@spawnry.ai',
            name: 'Spawnry Support'
        }
    },

    // Company Information
    company: {
        name: 'Spawnry',
        legalName: 'Teq Crew, LLC',
        copyright: 'Teq Crew, LLC dba Spawnry',
        website: 'https://spawnry.ai',
        tagline: 'Your story, ready for all platforms'
    },

    // Platform identifier for multi-tenancy
    platform: 'spawnry',

    // Redirect domain for invite links and other redirects
    redirectDomain: process.env.REACT_APP_REDIRECT_DOMAIN || 'http://localhost:3000',

    // Spawnry doesn't use tiered pricing yet - enterprise sales model
    // Keeping structure for future use
    pricing: {
        model: 'enterprise', // 'freemium', 'subscription', 'enterprise'
        contactForPricing: true,
        text: {
            cta: 'Contact Us',
            description: 'Enterprise pricing tailored to your needs.'
        }
    }
};

export default appConfig;
